// extracted by mini-css-extract-plugin
module.exports = {"OnePower":"OnePower_OnePower__a3V_b"};